// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SubmitRouteImport } from './routes/submit'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ReviewRouteImport } from './routes/review'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as RefundPolicyRouteImport } from './routes/refund-policy'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as NegotiationRouteImport } from './routes/negotiation'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DataRetentionRouteImport } from './routes/data-retention'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AiDisclaimerRouteImport } from './routes/ai-disclaimer'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OperationsIndexRouteImport } from './routes/operations.index'
import { Route as WorkspaceIdRouteImport } from './routes/workspace.$id'
import { Route as ReportIdRouteImport } from './routes/report.$id'
import { Route as OperationsRepairUploadsRouteImport } from './routes/operations.repair-uploads'
import { Route as DevRolesRouteImport } from './routes/dev.roles'
import { Route as DevPayPreviewRouteImport } from './routes/dev.pay-preview'
import { Route as CaseIdRouteImport } from './routes/case.$id'
import { Route as BillingSuccessRouteImport } from './routes/billing.success'
import { Route as BillingCancelRouteImport } from './routes/billing.cancel'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AdminLaunchChecklistRouteImport } from './routes/admin.launch-checklist'
import { Route as AdminEmailTestRouteImport } from './routes/admin.email-test'
import { Route as OperationsNegotiationsIndexRouteImport } from './routes/operations.negotiations.index'
import { Route as OperationsNegotiationsIdRouteImport } from './routes/operations.negotiations.$id'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const SubmitRoute = SubmitRouteImport.update({
            id: '/submit',path: '/submit',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const ReviewRoute = ReviewRouteImport.update({
            id: '/review',path: '/review',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const RefundPolicyRoute = RefundPolicyRouteImport.update({
            id: '/refund-policy',path: '/refund-policy',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const NotificationsRoute = NotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => rootRouteImport
          })
const NegotiationRoute = NegotiationRouteImport.update({
            id: '/negotiation',path: '/negotiation',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const DataRetentionRoute = DataRetentionRouteImport.update({
            id: '/data-retention',path: '/data-retention',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const AiDisclaimerRoute = AiDisclaimerRouteImport.update({
            id: '/ai-disclaimer',path: '/ai-disclaimer',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const OperationsIndexRoute = OperationsIndexRouteImport.update({
            id: '/operations/',path: '/operations/',getParentRoute: () => rootRouteImport
          })
const WorkspaceIdRoute = WorkspaceIdRouteImport.update({
            id: '/workspace/$id',path: '/workspace/$id',getParentRoute: () => rootRouteImport
          })
const ReportIdRoute = ReportIdRouteImport.update({
            id: '/report/$id',path: '/report/$id',getParentRoute: () => rootRouteImport
          })
const OperationsRepairUploadsRoute = OperationsRepairUploadsRouteImport.update({
            id: '/operations/repair-uploads',path: '/operations/repair-uploads',getParentRoute: () => rootRouteImport
          })
const DevRolesRoute = DevRolesRouteImport.update({
            id: '/dev/roles',path: '/dev/roles',getParentRoute: () => rootRouteImport
          })
const DevPayPreviewRoute = DevPayPreviewRouteImport.update({
            id: '/dev/pay-preview',path: '/dev/pay-preview',getParentRoute: () => rootRouteImport
          })
const CaseIdRoute = CaseIdRouteImport.update({
            id: '/case/$id',path: '/case/$id',getParentRoute: () => rootRouteImport
          })
const BillingSuccessRoute = BillingSuccessRouteImport.update({
            id: '/billing/success',path: '/billing/success',getParentRoute: () => rootRouteImport
          })
const BillingCancelRoute = BillingCancelRouteImport.update({
            id: '/billing/cancel',path: '/billing/cancel',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const AdminLaunchChecklistRoute = AdminLaunchChecklistRouteImport.update({
            id: '/admin/launch-checklist',path: '/admin/launch-checklist',getParentRoute: () => rootRouteImport
          })
const AdminEmailTestRoute = AdminEmailTestRouteImport.update({
            id: '/admin/email-test',path: '/admin/email-test',getParentRoute: () => rootRouteImport
          })
const OperationsNegotiationsIndexRoute = OperationsNegotiationsIndexRouteImport.update({
            id: '/operations/negotiations/',path: '/operations/negotiations/',getParentRoute: () => rootRouteImport
          })
const OperationsNegotiationsIdRoute = OperationsNegotiationsIdRouteImport.update({
            id: '/operations/negotiations/$id',path: '/operations/negotiations/$id',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AiDisclaimerRoute: AiDisclaimerRoute,DashboardRoute: DashboardRoute,DataRetentionRoute: DataRetentionRoute,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,NegotiationRoute: NegotiationRoute,NotificationsRoute: NotificationsRoute,PrivacyRoute: PrivacyRoute,RefundPolicyRoute: RefundPolicyRoute,RegisterRoute: RegisterRoute,ResetPasswordRoute: ResetPasswordRoute,ReviewRoute: ReviewRoute,SettingsRoute: SettingsRoute,SubmitRoute: SubmitRoute,SupportRoute: SupportRoute,TermsRoute: TermsRoute,VerifyEmailRoute: VerifyEmailRoute,AdminEmailTestRoute: AdminEmailTestRoute,AdminLaunchChecklistRoute: AdminLaunchChecklistRoute,AuthCallbackRoute: AuthCallbackRoute,BillingCancelRoute: BillingCancelRoute,BillingSuccessRoute: BillingSuccessRoute,CaseIdRoute: CaseIdRoute,DevPayPreviewRoute: DevPayPreviewRoute,DevRolesRoute: DevRolesRoute,OperationsRepairUploadsRoute: OperationsRepairUploadsRoute,ReportIdRoute: ReportIdRoute,WorkspaceIdRoute: WorkspaceIdRoute,OperationsIndexRoute: OperationsIndexRoute,OperationsNegotiationsIdRoute: OperationsNegotiationsIdRoute,OperationsNegotiationsIndexRoute: OperationsNegotiationsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)